import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { PopupToggler } from '../../blocks/PopupToggler';

import { ANALYTICS_SET_FILTER } from '../../../store/reducers/analytics';
import { MultipleFilter } from '../../filters/MultipleFilter';

import styles from './Dashboard.module.scss';

export function AnalyticsFilter(props) {
  const { options, selected } = props;

  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);

  const optionsWithoutSeparators = options.filter((option) => !option.separator);
  const hasSelected = selected.length > 0 && selected.length < optionsWithoutSeparators.length;

  const updateFilter = (values) => {
    if (props.onChange) {
      props.onChange(values);
    } else if (props.filterKey) {
      dispatch({ type: ANALYTICS_SET_FILTER, payload: { [props.filterKey]: values } });
    } else {
      console.error('AnalyticsFilter: no filterKey or onChange provided');
    }
  };

  return (
    <div className={cn(styles.analyticsFilter, hasSelected ? styles.hasSelected : '')}>
      <PopupToggler
        onTriggerClick={setExpanded}
        trigger={
          <span className={cn(styles.filterTrigger, expanded ? styles.expanded : '')}>
            {props.icon ?? null}
            {props.title}
          </span>
        }
        disabled={options.length === 0 || props.disabled}
      >
        {(closePopup) => (
          <MultipleFilter
            key={`trigger_${selected.join('_')}`}
            selected={selected}
            options={options}
            onReset={closePopup}
            onChange={(value) => {
              updateFilter(value);
              closePopup();
            }}
            withButtons
            withSelectAll
            withSearch={props.withSearch}
            allowEmpty={false}
            className={styles.filterOptionsWrapper}
            minWidth={252}
          />
        )}
      </PopupToggler>
    </div>
  );
}

AnalyticsFilter.propTypes = {
  title: PropTypes.string.isRequired,
  filterKey: PropTypes.string,
  options: PropTypes.any.isRequired,
  selected: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  withSearch: PropTypes.bool,
  icon: PropTypes.node,
  disabled: PropTypes.bool,
};
